import React, { Component, PropTypes } from 'react';
import { Button } from 'reactstrap';
import ConfirmLink from 'react-confirm-dialog';

import NavBar from './NavBar';
import NavLink from './NavLink';
import  { CREATE, UPDATE } from "../components/GroupForm";
import { spaceToUnderscore } from "../helpers/helpers";

class GroupFormLinks extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { assignment, dropbox, handleLeaveGroup, handleSubmit } = this.props;

        if (this.props.type === CREATE) {
            return (
                <NavBar
                    className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                >
                    <NavLink
                        to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}`}
                        className="btn btn-outline-primary btn-md"
                        side="left"
                        display
                        key="exit"
                    >
                        Exit To Assignment <i className={"fa fa-chevron-circle-left"}/>
                    </NavLink>
                    <NavLink
                        to="submit"
                        className=""
                        side="right"
                        display
                        key="submit"
                    >
                        <Button
                            type="button"
                            onClick={handleSubmit}
                            size="md"
                            color="success"
                            title={"Create"}
                        >
                            Create
                        </Button>
                    </NavLink>
                </NavBar>
            );
        }

        if (this.props.type === UPDATE) {
            return (
                <NavBar
                    className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                >
                    <NavLink
                        to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}`}
                        className="btn btn-outline-primary btn-md"
                        side="left"
                        display
                        key="exit"
                    >
                        Exit To Assignment <i className={"fa fa-chevron-circle-left"}/>
                    </NavLink>
                    <NavLink
                        to="submit"
                        className=""
                        side="right"
                        display
                        key="submit"
                    >
                        <Button
                            type="button"
                            onClick={handleSubmit}
                            size="md"
                            color="success"
                            title={"Update"}
                        >
                            Update
                        </Button>
                    </NavLink>
                    <NavLink
                        to="leave"
                        className=""
                        side="right"
                        display
                        key="leave"
                        onClick={(e) => {
                            e.preventDefault();
                        }}
                    >
                        <ConfirmLink
                            action={handleLeaveGroup}
                            confirmMessage={
                                `Are you sure you want to leave your group?
                                You will lose access to all uploaded files.`
                            }
                            confirmText={"Yes"}
                            cancelText={"No"}
                        >
                            <button className="float-right btn btn-md btn-danger" type="button">
                                Leave Group <i className="fa fa-times-circle" aria-hidden="true"/>
                            </button>
                        </ConfirmLink>
                    </NavLink>
                </NavBar>
            );
        }

        return null;
    }
}


GroupFormLinks.propTypes = {
    assignment: PropTypes.object.isRequired,
    dropbox: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleLeaveGroup: PropTypes.func,
    type: PropTypes.string.isRequired
};

export default GroupFormLinks;


/** WEBPACK FOOTER **
 ** ./src/components/GroupFormLinks.js
 **/